import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa6";
import { Navigation } from "swiper/modules";
import serviceBg from "../assets/service-bg.jpg";
import image1 from "../assets/image1.png";
import image2 from "../assets/image2.png";
import image3 from "../assets/image3.jpg";
import image4 from "../assets/image4.png";
import "swiper/css";

const Services = () => {
  const { t } = useTranslation();

  const services = [
    {
      id: 1,
      title: t("householdWaste"),
      image: image1,
    },
    {
      id: 2,
      title: t("mixedWetWaste"),
      image: image2,
    },
    {
      id: 3,
      title: t("drySolidWaste"),
      image: image3,
    },
    {
      id: 4,
      title: t("wetWaste"),
      image: image4,
    },
  ];
  return (
    <div className="mt-10 relative overflow-hidden md:mt-20">
      <div className="absolute inset-0">
        <img
          src={serviceBg}
          alt="services"
          className="w-full h-full object-cover"
        />

        <div className="absolute inset-0 bg-black/65"></div>
      </div>

      <div className="relative z-10 container mx-auto px-6 md:px-20 py-24">
        <div className="max-w-2xl">
          <div className="flex items-center gap-3 mb-6">
            <div className="w-8 h-[1px] bg-white"></div>

            <p className="text-white/80 text-sm md:text-base">
              {t("services")}
            </p>
          </div>

          <h1 className="text-2xl text-start max-w-320 text-white !leading-tight md:text-4xl font-light mb-8 md:mb-4 lg:mb-6 lg:text-5xl xl:text-6xl">
            {t("whatWaste")}
          </h1>
        </div>

        <div className="mt-16">
          <Swiper
            modules={[Navigation]}
            spaceBetween={20}
            slidesPerView={1.2}
            navigation={{
              nextEl: ".custom-next",
              prevEl: ".custom-prev",
            }}
            breakpoints={{
              640: {
                slidesPerView: 1,
              },
              768: {
                slidesPerView: 2,
              },
              1024: {
                slidesPerView: 3,
              },
              1280: {
                slidesPerView: 4,
              },
            }}
          >
            {services.map((service) => (
              <SwiperSlide key={service.id}>
                <Link to="/services" className="group block cursor-pointer">
                  <div className="overflow-hidden rounded-[32px] h-[260px]">
                    <img
                      src={service.image}
                      alt={service.title}
                      className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-110"
                    />
                  </div>

                  <h3 className="text-white text-lg md:text-xl mt-4 leading-snug">
                    {service.title}
                  </h3>
                </Link>
              </SwiperSlide>
            ))}
          </Swiper>
          <div className="flex items-center justify-center gap-4 mt-10 xl:hidden">
            <button className="custom-prev w-12 h-12 rounded-full border border-white text-white flex items-center justify-center transition-all duration-300 hover:bg-white hover:text-black">
              <FaArrowLeft />
            </button>

            <button className="custom-next w-12 h-12 rounded-full border border-white text-white flex items-center justify-center transition-all duration-300 hover:bg-white hover:text-black">
              <FaArrowRight />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Services;
